<template>
  <div class="bg-ontick-graphite-500 col-span-1 rounded p-4 shadow md:col-span-2">
    <div class="divide-ontick-steel-500 flex flex-col divide-y">
      <div class="flex flex-col gap-4 pb-4">
        <h3 class="text-lg font-bold sm:text-2xl">Dados para pagamento</h3>
        <div class="flex flex-col gap-4">
          <custom-input-component
            v-model="payer.name"
            label="Nome"
            name="name"
            placeholder="Ontickerson Moneymaker"
            v-validate="'required'"
            :errorMessage="errors.first('name')"
          />
          <custom-input-component
            v-model="payer.email"
            label="E-mail"
            name="email"
            type="email"
            placeholder="ontickerson@ontick.com.br"
            v-validate="'required'"
            :errorMessage="errors.first('email')"
          />
          <custom-input-component
            v-model="payer.cpf"
            label="CPF"
            name="cpf"
            mask="###.###.###-##"
            placeholder="123.456.789-01"
            v-validate="'required|length:14|cpf'"
            :errorMessage="errors.first('cpf')"
          />
          <custom-input-component
            v-model="payer.phone"
            label="Telefone"
            name="phone"
            :mask="'(##) #####-####'"
            placeholder="(11) 99999-9999"
            type="tel"
            v-validate="'required|min:14'"
            :errorMessage="errors.first('phone')"
          />
        </div>
      </div>
      <div class="flex flex-col gap-4 pt-4">
        <h4 class="font-bold">Endereço</h4>
        <div class="flex flex-col gap-4">
          <div class="flex flex-col gap-4 sm:flex-row">
            <div class="relative">
              <custom-input-component
                v-model="payer.cep"
                label="CEP"
                name="cep"
                mask="#####-###"
                placeholder="12345-678"
                v-validate="'required|length:9'"
                :errorMessage="errors.first('cep')"
              />
              <div v-if="loadingCep" class="absolute bottom-2 right-2 transform">
                <i v-html="$icons.loading"></i>
                <span class="sr-only"> Carregando </span>
              </div>
            </div>
            <custom-input-component
              v-model="payer.number"
              label="Número"
              name="number"
              placeholder="275"
              v-validate="'required'"
              :errorMessage="errors.first('number')"
            />
          </div>
          <custom-input-component
            v-model="payer.street"
            label="Rua"
            name="street"
            placeholder="R. Quinze de Novembro"
            v-validate="'required'"
            :errorMessage="errors.first('street')"
          />
          <div class="flex flex-col gap-4 sm:flex-row">
            <custom-input-component
              v-model="payer.neighborhood"
              label="Bairro"
              name="neighborhood"
              placeholder="Centro Histórico"
              v-validate="'required'"
              :errorMessage="errors.first('neighborhood')"
            />
            <custom-input-component
              v-model="payer.city"
              label="Cidade"
              name="city"
              placeholder="São Paulo"
              v-validate="'required'"
              :errorMessage="errors.first('city')"
            />
            <custom-input-component
              :value="payer.uf"
              @input="payer.uf = $event.toUpperCase()"
              label="UF"
              name="uf"
              mask="AA"
              placeholder="SP"
              v-validate="'required|length:2'"
              :errorMessage="errors.first('uf')"
            />
          </div>
          <custom-input-component
            v-model="payer.complement"
            label="Complemento"
            name="complement"
            placeholder="Ex.: Apto 104"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import customInputComponent from "./custom-input.component.vue";
import event_bus from "../../../shared/utils/event_bus";
import { Auth } from "aws-amplify";

export default {
  components: {
    customInputComponent,
  },

  props: {
    loadingCep: {
      type: Boolean,
    },
  },

  data() {
    return {
      payer: {
        name: null,
        cpf: null,
        cep: null,
        number: null,
        street: null,
        neighborhood: null,
        city: null,
        uf: null,
        complement: null,
        email: null,
        phone: null,
      },
      cpfIsInvalid: false,
    };
  },

  methods: {
    validarCPF(cpf) {
      return new Promise((resolve) => {
        cpf = cpf.replace(/[^\d]+/g, "");
        if (cpf == "") resolve(false);
        // Elimina CPFs invalidos conhecidos
        if (
          cpf.length != 11 ||
          cpf == "00000000000" ||
          cpf == "11111111111" ||
          cpf == "22222222222" ||
          cpf == "33333333333" ||
          cpf == "44444444444" ||
          cpf == "55555555555" ||
          cpf == "66666666666" ||
          cpf == "77777777777" ||
          cpf == "88888888888" ||
          cpf == "99999999999"
        )
          resolve(false);
        // Valida 1o digito
        let add = 0;
        for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i);
        let rev = 11 - (add % 11);
        if (rev == 10 || rev == 11) rev = 0;
        if (rev != parseInt(cpf.charAt(9))) resolve(false);
        // Valida 2o digito
        add = 0;
        for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i);
        rev = 11 - (add % 11);
        if (rev == 10 || rev == 11) rev = 0;
        if (rev != parseInt(cpf.charAt(10))) resolve(false);
        resolve(true);
      });
    },
  },

  watch: {
    payer: {
      deep: true,
      handler(val) {
        this.$emit("payerInput", val);
        if (val.cpf?.length === 14) {
          this.cpfIsInvalid = this.validarCPF(val.cpf);
        } else {
          this.cpfIsInvalid = false;
        }
      },
    },
  },

  mounted() {
    function checkTemplateValue(value) {
      if (value === " " || value === "1") {
        return "";
      }
      return value;
    }
    Auth.currentAuthenticatedUser()
      .then(() => {
        this.$api
          .get(this.$endpoint.GET_USER_INFO)
          .then((res) => {
            let data = res.data;
            this.payer.name = checkTemplateValue(data.user_name);
            this.payer.cpf = checkTemplateValue(data.preferred_username);
            this.payer.cep = checkTemplateValue(data.user_cep);
            this.payer.number = checkTemplateValue(data.user_address_number);
            this.payer.street = checkTemplateValue(data.user_address);
            this.payer.neighborhood = checkTemplateValue(data.user_neighborhood);
            this.payer.city = checkTemplateValue(data.user_city);
            this.payer.uf = checkTemplateValue(data.user_state);
            this.payer.complement = checkTemplateValue(data.user_address_complement);
            this.payer.email = checkTemplateValue(data.user_email);
            this.payer.phone = checkTemplateValue(data.user_phone).slice(3);
          })
          .catch((err) => {
            console.error(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
    event_bus.$on("VALIDATE", () => {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.$emit("validated");
        }
      });
    });
  },
};
</script>

<style></style>
